module.exports = __webpack_public_path__ + "img/logo-nav.113f22a2.webp";